import useNiveauxGarantiesTarifsPrevTnsIncapaciteTemporaireDeTravailForm from '../hooks/useNiveauxGarantiesTarifsPrevTnsIncapaciteTemporaireDeTravailForm';
import { ControlledRadioButton, ControlledSwitch } from '@@viewCommonComponents/controlled';
import { Collapse, Message, SectionTitle, TotalTable } from '@fasstech/middle-design-system';
import mapOfferNodeOptions from '@@viewHelpers/mapOfferNodeOptions';
import useChildren from '../hooks/useChildren.js';
import AddGrantee from './AddGrantee.jsx';
import extraMadelin from '../extra/extraMadelin.js';

const NiveauxGarantiesTarifsPrevTnsIncapaciteTemporaireDeTravailForm = ({
  form,
  guarantees,
  getMiddleText,
  getMiddleBoolean,
  getMiddleNumber,
  minBirthDateReducChild,
  maxBirthDateReducChild,
  minBirthDateHospiChild,
  maxBirthDateHospiChild,
  onOptionFrMalChange,
  onOptionFrAccChange,
  onOptionFrHospChange
}) => {
  const {
    optionFraisGeneraux,
    watchedWarrantyFields,
    isGarIncapRequired,
    childErrorHospi,
    garIncap,
    incapHospiChild,
    childrenGuaranteeIsRequired,
    OPTION_INCAP,
    INCAP_MAD,
    OPTION_ZERO_SIN,
    OPTION_EXO_COT,
    OPTION_CONFORT_PSY,
    OPTION_HOSP_ENF_GAR,
    HOSP_ENF_MAD,
    OPTION_FR_GEN,
    HOSP_ENF_ALLOW_AMOUNT,
    incapCotisation,
    updateRadioButtonSelectedIndex
  } = useNiveauxGarantiesTarifsPrevTnsIncapaciteTemporaireDeTravailForm({
    form,
    guarantees,
    getMiddleText,
    getMiddleBoolean
  });

  const {
    children,
    childIsRequired,
    addChild,
    deleteChild,
    childHasBirthDate,
    setEditingChild,
    isChildMaxCountReached,
    nbMaxChild,
    maxGranteeAgeIncapHospiChild
  } = useChildren({
    form,
    getMiddleNumber,
    minBirthDateReducChild,
    maxBirthDateReducChild,
    minBirthDateHospiChild,
    maxBirthDateHospiChild
  });

  return (
    <Collapse title={getMiddleText('NIVEAUXGARANTIESETTARIFS_GAR_INCAP_LABEL')}>
      <div className="flex gap-10 flex-col-reverse md:flex-row">
        {/*Left column*/}
        <div className="flex-1">
          <ControlledSwitch
            name="guarantees.OPTION_INCAP.selected"
            label={getMiddleText('NIVEAUXGARANTIESETTARIFS_GAR_INCAP_CHOIX_LABEL')}
            labelClassNames="text-lg"
            rules={isGarIncapRequired(watchedWarrantyFields)}
            displayError={false}
            disabled={!OPTION_INCAP.editable}
            form={form}
            recommended={OPTION_INCAP.recommended}
            infoMessage={getMiddleText('NIVEAUXGARANTIESETTARIFS_GAR_INCAP_MESSAGE_INFO')}
            data-testid="OPTION_INCAP"
          />

          {garIncap && (
            <>
              <hr className="mt-8 mb-6" />

              <div className="grid grid-cols-1 md:grid-cols-2! gap-8">
                {getMiddleBoolean(
                  'NIVEAUXGARANTIESETTARIFS_GAR_INCAP_FRANCHISE_MALADIE_EST_NECESSAIRE'
                ) && (
                  <div>
                    <div className="mr-4">
                      <p className="font-bold">
                        {getMiddleText(
                          'NIVEAUXGARANTIESETTARIFS_GAR_INCAP_FRANCHISE_MALADIE_LABEL'
                        )}
                      </p>
                      <ControlledRadioButton
                        withIndicator={false}
                        isMultiline
                        isResponsiveCol
                        form={form}
                        name="guarantees.OPTION_FR_MAL.value"
                        options={mapOfferNodeOptions(guarantees.OPTION_FR_MAL)}
                        extraChange={onOptionFrMalChange}
                        data-testid="OPTION_FR_MAL"
                      />
                    </div>
                    <Message
                      variant="info"
                      label={getMiddleText(
                        'NIVEAUXGARANTIESETTARIFS_GAR_INCAP_FRANCHISE_MALADIE_MESSAGE_INFO'
                      )}
                    />
                  </div>
                )}
                {getMiddleBoolean(
                  'NIVEAUXGARANTIESETTARIFS_GAR_INCAP_FRANCHISE_ACCIDENT_EST_NECESSAIRE'
                ) && (
                  <div>
                    <div>
                      <p className="font-bold">
                        {getMiddleText(
                          'NIVEAUXGARANTIESETTARIFS_GAR_INCAP_FRANCHISE_ACCIDENT_LABEL'
                        )}
                      </p>
                      <ControlledRadioButton
                        withIndicator={false}
                        isMultiline
                        isResponsiveCol
                        form={form}
                        name="guarantees.OPTION_FR_ACC.value"
                        options={mapOfferNodeOptions(guarantees.OPTION_FR_ACC)}
                        extraChange={onOptionFrAccChange}
                        data-testid="OPTION_FR_ACC"
                      />
                    </div>
                    <Message
                      variant="info"
                      label={getMiddleText(
                        'NIVEAUXGARANTIESETTARIFS_GAR_INCAP_FRANCHISE_ACCIDENT_MESSAGE_INFO'
                      )}
                    />
                  </div>
                )}

                {getMiddleBoolean(
                  'NIVEAUXGARANTIESETTARIFS_GAR_INCAP_FRANCHISE_HOSPITALISATION_EST_NECESSAIRE'
                ) && (
                  <div>
                    <div className="mr-4">
                      <p className="font-bold">
                        {getMiddleText(
                          'NIVEAUXGARANTIESETTARIFS_GAR_INCAP_FRANCHISE_HOSPITALISATION_LABEL'
                        )}
                      </p>
                      <ControlledRadioButton
                        withIndicator={false}
                        isMultiline
                        isResponsiveCol
                        form={form}
                        name="guarantees.OPTION_FR_HOSP.value"
                        options={mapOfferNodeOptions(guarantees.OPTION_FR_HOSP)}
                        extraChange={onOptionFrHospChange}
                        data-testid="OPTION_FR_HOSP"
                      />
                    </div>
                    <Message
                      variant="info"
                      label={getMiddleText(
                        'NIVEAUXGARANTIESETTARIFS_GAR_INCAP_FRANCHISE_HOSPITALISATION_MESSAGE_INFO'
                      )}
                    />
                  </div>
                )}
                {getMiddleBoolean(
                  'NIVEAUXGARANTIESETTARIFS_GAR_INCAP_FRANCHISE_TTES_CAUSES_EST_NECESSAIRE'
                ) && (
                  <div>
                    <div>
                      <p className="font-bold">
                        {getMiddleText(
                          'NIVEAUXGARANTIESETTARIFS_GAR_INCAP_FRANCHISE_TTES_CAUSES_LABEL'
                        )}
                      </p>
                      <ControlledRadioButton
                        withIndicator={false}
                        isMultiline
                        isResponsiveCol
                        form={form}
                        name="guarantees.OPTION_FR_ALL.value"
                        options={mapOfferNodeOptions(guarantees.OPTION_FR_ALL)}
                        data-testid="OPTION_FR_ALL"
                      />
                    </div>
                    <Message
                      variant="info"
                      label={getMiddleText(
                        'NIVEAUXGARANTIESETTARIFS_GAR_INCAP_FRANCHISE_TTES_CAUSES_MESSAGE_INFO'
                      )}
                    />
                  </div>
                )}
              </div>

              <SectionTitle>
                {getMiddleText('NIVEAUXGARANTIESETTARIFS_GAR_INCAP_CAPITAL_LABEL')}
              </SectionTitle>
              <div>
                <ControlledRadioButton
                  withIndicator={false}
                  isMultiline
                  isResponsiveCol
                  form={form}
                  name="guarantees.OPTION_INCAP_CAP.value"
                  options={mapOfferNodeOptions(guarantees.OPTION_INCAP_CAP)}
                  data-testid="OPTION_INCAP_CAP"
                  extraChange={updateRadioButtonSelectedIndex('OPTION_INCAP_CAP')}
                />
              </div>
              <p className="mb-4">
                {getMiddleText('NIVEAUXGARANTIESETTARIFS_GAR_INCAP_CAPITAL_LEGENDE')}
              </p>

              {INCAP_MAD && (
                <ControlledSwitch
                  extraClick={() => extraMadelin(INCAP_MAD.selected, form)}
                  name="guarantees.INCAP_MAD.selected"
                  label={getMiddleText('NIVEAUXGARANTIESETTARIFS_GAR_INCAP_FISCA_MADELIN_LABEL')}
                  containerClassName="mb-8"
                  labelClassNames="text-lg"
                  disabled={!INCAP_MAD.editable}
                  form={form}
                  displayError={false}
                  data-testid="INCAP_MAD"
                />
              )}

              <hr className="mb-6" />

              {getMiddleBoolean('NIVEAUXGARANTIESETTARIFS_GAR_INCAP_OPTION_EST_NECESSAIRE') && (
                <>
                  <SectionTitle>
                    {getMiddleText('NIVEAUXGARANTIESETTARIFS_GAR_INCAP_OPTION_LABEL')}
                  </SectionTitle>

                  {OPTION_ZERO_SIN &&
                    getMiddleBoolean(
                      'NIVEAUXGARANTIESETTARIFS_GAR_INCAP_OPTION_ZERO_SINISTRE_EST_NECESSAIRE'
                    ) && (
                    <ControlledSwitch
                      name="guarantees.OPTION_ZERO_SIN.selected"
                      label={getMiddleText(
                        'NIVEAUXGARANTIESETTARIFS_GAR_INCAP_OPTION_ZERO_SINISTRE_LABEL'
                      )}
                      containerClassName="mb-2"
                      labelClassNames="text-lg"
                      disabled={!OPTION_ZERO_SIN.editable}
                      form={form}
                      displayError={false}
                      recommended={OPTION_ZERO_SIN.recommended}
                      infoMessage={getMiddleText(
                        'NIVEAUXGARANTIESETTARIFS_GAR_INCAP_OPTION_ZERO_SINISTRE_MESSAGE_INFO'
                      )}
                      data-testid="OPTION_ZERO_SIN"
                    />
                  )}

                  {OPTION_EXO_COT &&
                    getMiddleBoolean(
                      'NIVEAUXGARANTIESETTARIFS_GAR_INCAP_OPTION_EXO_COTISATION_EST_NECESSAIRE'
                    ) && (
                    <ControlledSwitch
                      name="guarantees.OPTION_EXO_COT.selected"
                      label={getMiddleText(
                        'NIVEAUXGARANTIESETTARIFS_GAR_INCAP_OPTION_EXO_COTISATION_LABEL'
                      )}
                      containerClassName="mb-2"
                      labelClassNames="text-lg"
                      displayError={false}
                      disabled={!OPTION_EXO_COT.editable}
                      form={form}
                      recommended={OPTION_EXO_COT.recommended}
                      infoMessage={getMiddleText(
                        'NIVEAUXGARANTIESETTARIFS_GAR_INCAP_OPTION_EXO_COTISATION_MESSAGE_INFO'
                      )}
                      data-testid="OPTION_EXO_COT"
                    />
                  )}

                  {
                    OPTION_CONFORT_PSY &&
                    getMiddleBoolean(
                      'NIVEAUXGARANTIESETTARIFS_GAR_INCAP_OPTION_CONFORT_PSY_EST_NECESSAIRE'
                    ) && (
                      <ControlledSwitch
                        name="guarantees.OPTION_CONFORT_PSY.selected"
                        label={getMiddleText(
                          'NIVEAUXGARANTIESETTARIFS_GAR_INCAP_OPTION_CONFORT_PSY_LABEL'
                        )}
                        containerClassName="mb-2"
                        labelClassNames="text-lg"
                        disabled={!OPTION_CONFORT_PSY.editable}
                        form={form}
                        displayError={false}
                        recommended={OPTION_CONFORT_PSY.recommended}
                        infoMessage={getMiddleText(
                          'NIVEAUXGARANTIESETTARIFS_GAR_INCAP_OPTION_CONFORT_PSY_MESSAGE_INFO'
                        )}
                        data-testid="OPTION_CONFORT_PSY"
                      />
                    )}

                  {OPTION_HOSP_ENF_GAR &&
                    getMiddleBoolean(
                      'NIVEAUXGARANTIESETTARIFS_GAR_INCAP_OPTION_HOSPI_CHILD_EST_NECESSAIRE'
                    ) && (
                    <ControlledSwitch
                      name="guarantees.OPTION_HOSP_ENF_GAR.selected"
                      label={getMiddleText(
                        'NIVEAUXGARANTIESETTARIFS_GAR_INCAP_OPTION_HOSPI_CHILD_LABEL'
                      )}
                      containerClassName="mb-2"
                      labelClassNames="text-lg"
                      rules={childIsRequired(children, childErrorHospi)}
                      displayError={false}
                      disabled={!OPTION_HOSP_ENF_GAR.editable}
                      form={form}
                      recommended={OPTION_HOSP_ENF_GAR.recommended}
                      infoMessage={getMiddleText(
                        'NIVEAUXGARANTIESETTARIFS_GAR_INCAP_OPTION_HOSPI_CHILD_MESSAGE_INFO'
                      )}
                      data-testid="OPTION_HOSP_ENF_GAR"
                    />
                  )}

                  {incapHospiChild && (
                    <>
                      <AddGrantee
                        icon="stroller"
                        title="Enfant(s)"
                        buttonTitle={'Ajouter des enfants'}
                        infoTooltip={getMiddleText(
                          'NIVEAUXGARANTIESETTARIFS_GAR_INCAP_OPTION_HOSPI_CHILD_INFO',
                          {
                            maxGranteeAge: maxGranteeAgeIncapHospiChild
                          }
                        )}
                        grantees={children}
                        addGrantee={addChild}
                        deleteGrantee={deleteChild}
                        setEditingGrantee={setEditingChild}
                        granteeHasBirthDate={childHasBirthDate}
                        form={form}
                        minBirthDate={minBirthDateHospiChild}
                        maxBirthDate={maxBirthDateHospiChild}
                        isMaxCountReached={isChildMaxCountReached}
                        maxCountMessage={getMiddleText('BENEFICIAIRE_TYPE_MAX_CHILD_ATTEINT', {
                          nbMaxChild
                        })}
                        formName={'children'}
                        dataTestId="childHospi"
                        getMiddleText={getMiddleText}
                      />
                      <div>
                        <p className="font-bold">
                          {getMiddleText(
                            'NIVEAUXGARANTIESETTARIFS_GAR_INCAP_OPTION_HOSPI_CHILD_MT_IJ_LABEL'
                          )}
                        </p>
                        <ControlledRadioButton
                          withIndicator={false}
                          isMultiline
                          isResponsiveCol
                          form={form}
                          name="guarantees.HOSP_ENF_ALLOW_AMOUNT.value"
                          size="small"
                          options={mapOfferNodeOptions(HOSP_ENF_ALLOW_AMOUNT)}
                          rules={childrenGuaranteeIsRequired}
                          data-testid="HOSP_ENF_ALLOW_AMOUNT"
                        />
                      </div>

                      {HOSP_ENF_MAD && (
                        <ControlledSwitch
                          extraClick={() => extraMadelin(HOSP_ENF_MAD.selected, form)}
                          name="guarantees.HOSP_ENF_MAD.selected"
                          label={getMiddleText(
                            'NIVEAUXGARANTIESETTARIFS_GAR_INCAP_OPTION_HOSPI_CHILD_FISCA_MADELIN_LABEL'
                          )}
                          containerClassName="ml-3 mb-4"
                          labelClassNames="text-lg"
                          disabled={!HOSP_ENF_MAD.editable}
                          form={form}
                          displayError={false}
                          data-testid="HOSP_ENF_MAD"
                        />
                      )}
                    </>
                  )}
                </>
              )}

              <hr className="mt-6 mb-4" />

              {OPTION_FR_GEN &&
                getMiddleBoolean(
                  'NIVEAUXGARANTIESETTARIFS_GAR_INCAP_OPTION_FRAIS_GENERAUX_EST_NECESSAIRE'
                ) && (
                <>
                  <ControlledSwitch
                    name="guarantees.OPTION_FR_GEN.selected"
                    label={getMiddleText(
                      'NIVEAUXGARANTIESETTARIFS_GAR_INCAP_OPTION_FRAIS_GENERAUX_LABEL'
                    )}
                    containerClassName="ml-3 mb-4"
                    labelClassNames="text-lg font-bold"
                    disabled={!OPTION_FR_GEN.editable}
                    form={form}
                    displayError={false}
                    recommended={OPTION_FR_GEN.recommended}
                    infoMessage={getMiddleText(
                      'NIVEAUXGARANTIESETTARIFS_GAR_INCAP_OPTION_FRAIS_GENERAUX_MESSAGE_INFO'
                    )}
                    data-testid="OPTION_FR_GEN"
                  />

                  {optionFraisGeneraux && (
                    <>
                      <div className="grid grid-cols-1 md:grid-cols-2! gap-8">
                        {getMiddleBoolean(
                          'NIVEAUXGARANTIESETTARIFS_GAR_INCAP_OPTION_FRAIS_GENERAUX_FRANCHISE_MALADIE_EST_NECESSAIRE'
                        ) && (
                          <div>
                            <div className="mr-4">
                              <p className="font-bold">
                                {getMiddleText(
                                  'NIVEAUXGARANTIESETTARIFS_GAR_INCAP_OPTION_FRAIS_GENERAUX_FRANCHISE_MALADIE_LABEL'
                                )}
                              </p>
                              <ControlledRadioButton
                                withIndicator={false}
                                isMultiline
                                isResponsiveCol
                                name="guarantees.OPTION_FR_GEN_FR_MAL.value"
                                options={mapOfferNodeOptions(guarantees.OPTION_FR_GEN_FR_MAL)}
                                form={form}
                                data-testid="OPTION_FR_GEN_FR_MAL"
                              />
                            </div>
                            <Message
                              variant="info"
                              label={getMiddleText(
                                'NIVEAUXGARANTIESETTARIFS_GAR_INCAP_OPTION_FRAIS_GENERAUX_FRANCHISE_MALADIE_MESSAGE_INFO'
                              )}
                            />
                          </div>
                        )}
                        {getMiddleBoolean(
                          'NIVEAUXGARANTIESETTARIFS_GAR_INCAP_OPTION_FRAIS_GENERAUX_FRANCHISE_ACCIDENT_EST_NECESSAIRE'
                        ) && (
                          <div>
                            <div>
                              <p className="font-bold">
                                {getMiddleText(
                                  'NIVEAUXGARANTIESETTARIFS_GAR_INCAP_OPTION_FRAIS_GENERAUX_FRANCHISE_ACCIDENT_LABEL'
                                )}
                              </p>
                              <ControlledRadioButton
                                withIndicator={false}
                                isMultiline
                                isResponsiveCol
                                name="guarantees.OPTION_FR_GEN_FR_ACC.value"
                                options={mapOfferNodeOptions(guarantees.OPTION_FR_GEN_FR_ACC)}
                                form={form}
                                data-testid="OPTION_FR_GEN_FR_ACC"
                              />
                            </div>
                            <Message
                              variant="info"
                              label={getMiddleText(
                                'NIVEAUXGARANTIESETTARIFS_GAR_INCAP_OPTION_FRAIS_GENERAUX_FRANCHISE_ACCIDENT_MESSAGE_INFO'
                              )}
                            />
                          </div>
                        )}

                        {getMiddleBoolean(
                          'NIVEAUXGARANTIESETTARIFS_GAR_INCAP_OPTION_FRAIS_GENERAUX_FRANCHISE_HOSPITALISATION_EST_NECESSAIRE'
                        ) && (
                          <div>
                            <div className="mr-4">
                              <p className="font-bold">
                                {getMiddleText(
                                  'NIVEAUXGARANTIESETTARIFS_GAR_INCAP_OPTION_FRAIS_GENERAUX_FRANCHISE_HOSPITALISATION_LABEL'
                                )}
                              </p>
                              <ControlledRadioButton
                                withIndicator={false}
                                isMultiline
                                isResponsiveCol
                                name="guarantees.OPTION_FR_GEN_FR_HOSP.value"
                                options={mapOfferNodeOptions(guarantees.OPTION_FR_GEN_FR_HOSP)}
                                form={form}
                                data-testid="OPTION_FR_GEN_FR_HOSP"
                              />
                            </div>
                            <Message
                              variant="info"
                              label={getMiddleText(
                                'NIVEAUXGARANTIESETTARIFS_GAR_INCAP_OPTION_FRAIS_GENERAUX_FRANCHISE_HOSPITALISATION_MESSAGE_INFO'
                              )}
                            />
                          </div>
                        )}
                        {getMiddleBoolean(
                          'NIVEAUXGARANTIESETTARIFS_GAR_INCAP_OPTION_FRAIS_GENERAUX_FRANCHISE_TTES_CAUSES_EST_NECESSAIRE'
                        ) && (
                          <div>
                            <div>
                              <p className="font-bold">
                                {getMiddleText(
                                  'NIVEAUXGARANTIESETTARIFS_GAR_INCAP_OPTION_FRAIS_GENERAUX_FRANCHISE_TTES_CAUSES_LABEL'
                                )}
                              </p>
                              <ControlledRadioButton
                                withIndicator={false}
                                isMultiline
                                isResponsiveCol
                                name="guarantees.OPTION_FR_GEN_FR_TT_CAUSE.value"
                                options={mapOfferNodeOptions(
                                  guarantees.OPTION_FR_GEN_FR_TT_CAUSE
                                )}
                                form={form}
                                data-testid="OPTION_FR_GEN_FR_TT_CAUSE"
                              />
                            </div>
                            <Message
                              variant="info"
                              label={getMiddleText(
                                'NIVEAUXGARANTIESETTARIFS_GAR_INCAP_OPTION_FRAIS_GENERAUX_FRANCHISE_TTES_CAUSES_MESSAGE_INFO'
                              )}
                            />
                          </div>
                        )}
                      </div>

                      <p className="font-bold">
                        {getMiddleText(
                          'NIVEAUXGARANTIESETTARIFS_GAR_INCAP_OPTION_FRAIS_GENERAUX_CAPITAL_LABEL'
                        )}
                      </p>
                      <div>
                        <ControlledRadioButton
                          withIndicator={false}
                          isMultiline
                          isResponsiveCol
                          name="guarantees.FR_GEN_CAP.value"
                          options={mapOfferNodeOptions(form.watch('guarantees.FR_GEN_CAP'))}
                          form={form}
                          data-testid="FR_GEN_CAP"
                          extraChange={updateRadioButtonSelectedIndex('FR_GEN_CAP')}
                        />
                      </div>
                      <p className="mb-4">
                        {getMiddleText(
                          'NIVEAUXGARANTIESETTARIFS_GAR_INCAP_OPTION_FRAIS_GENERAUX_CAPITAL_LEGENDE'
                        )}
                      </p>
                    </>
                  )}
                </>
              )}

              <TotalTable rows={incapCotisation} />
            </>
          )}
        </div>
      </div>
    </Collapse>
  );
};

export default NiveauxGarantiesTarifsPrevTnsIncapaciteTemporaireDeTravailForm;
